import Vue from 'vue'
import VueI18n from 'vue-i18n'
import moment from 'moment'
import mergeMessage from './modules'
// import { axios } from '@/utils/request'

// default lang
// import zhCN from './lang/zh_CN'
import ANTzhCN from 'ant-design-vue/es/locale/zh_CN'
import ANTenUS from 'ant-design-vue/es/locale/en_US'
import ANTkoKR from 'ant-design-vue/es/locale/ko_KR'

Vue.use(VueI18n)

export const defaultLang = 'zh_CN'

// const messages = {
//   'zh_CN': {
//     ...zhCN
//   }
// }
sessionStorage.setItem('refresh-windows-time', moment().format('MMMM Do YYYY, h:mm:ss a'))

const i18n = new VueI18n({
  silentTranslationWarn: true
})

// const i18n = new VueI18n({
//   silentTranslationWarn: true,
//   locale: defaultLang,
//   fallbackLocale: defaultLang,
//   messages
// })

// const loadedLanguages = ['zh_CN']
function concatLanguage (data, lang) {
  let langCodes = {
    'zh_CN': 'cn',
    'en_US': 'en',
    'ko_KR': 'kr'
  }
  let _data = {}
  for (let i of Object.keys(data)) {
    _data[i] = data[i][langCodes[lang]] || data[i]['en']
  }
  return _data
}

function setI18nLanguage (lang) {
  i18n.locale = lang
  document.querySelector('html').setAttribute('lang', lang.substr(0, 2))
  return lang
}
export function loadLanguageAsync (lang = defaultLang) {
  return new Promise((resolve, reject) => {
    return import (/* webpackChunkName: "lang-[request]" */ `./lang/${lang}`).then(msg => {
      // antLang = msg.antLang
      const locale = Object.assign(msg.default, concatLanguage(mergeMessage, lang))
      i18n.setLocaleMessage(lang, locale)
      moment.locale(locale.momentName)
      Vue.prototype.$moment = moment
      resolve(setI18nLanguage(lang))
    }).catch((e) => {
      reject(new Error('not language', e))
    })
  })
}

// const i18n = new VueI18n({
//   silentTranslationWarn: true,
//   locale: defaultLang,
//   fallbackLocale: defaultLang,
//   messages
// })

// const loadedLanguages = ['zh_CN']

// function setI18nLanguage (lang) {
//   i18n.locale = lang
//   // axios.defaults.headers['Accept-Language'] = lang
//   document.querySelector('html').setAttribute('lang', lang.substr(0, 2))
//   return lang
// }

// export function loadLanguageAsync (lang = defaultLang) {
//   return new Promise(resolve => {
//     // 缓存语言设置
//     if (i18n.locale !== lang) {
//       if (!loadedLanguages.includes(lang)) {
//         return import(/* webpackChunkName: "lang-[request]" */ `./lang/${lang}`).then(msg => {
//           const locale = msg.default
//           i18n.setLocaleMessage(lang, locale)
//           loadedLanguages.push(lang)
//           moment.updateLocale(locale.momentName, locale.momentLocale)
//           resolve(setI18nLanguage(lang))
//         })
//       }
//       return resolve(setI18nLanguage(lang))
//     }
//     return resolve(lang)
//   })
// }

export function i18nRender (key, codes = []) {
  return i18n.t(`${key}`, codes)
}
export function getAntLangPack (lang) {
  return {
    'zh_CN': ANTzhCN,
    'en_US': ANTenUS,
    'ko_KR': ANTkoKR
  }[lang]
}
export default i18n
